"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var utils_1 = require("../../core/utils");
/**
 * Utility class that speeds up lookup of category by id and access to category's parent or children. The class internally
 * converts provided list of categories (order does not matter) into mapping from id to category.
 * During conversion it is tested that provided categories form a tree. The test is performed only by parentId attribute
 * of categories. That means categories can have more children ids associated, than there are children categories. This
 * is useful, when working with only a subtree of the whole category tree without modifying the category objects.
 * Empty tree is allowed.
 *
 * @author Stepan Mik
 * @author Radek Beran
 */


var ProductCategoryTree =
/*#__PURE__*/
function () {
  function ProductCategoryTree(cats) {
    var _this = this;

    _classCallCheck(this, ProductCategoryTree);

    this.catmap = new Map();
    var roots = new Map();
    cats.forEach(function (c) {
      _this.catmap.set(c.id, c);

      var p = c.parentId || '';
      var pr = roots.get(p);

      if (roots.get(p) !== false) {
        if (pr === undefined) {
          roots.set(p, pr = ['', 0]);
        }

        pr[0] = c.id;
        pr[1]++;
      }

      roots.set(c.id, false);
    });
    var r = null;
    roots.forEach(function (v) {
      if (v !== false) {
        if (r !== null) {
          throw new Error('Provided categories do not form a tree.');
        }

        r = v;
      }
    });

    if (r === null) {
      this._root = null; // empty tree
    } else {
      if (r[1] > 1) {
        throw new Error('Provided categories do not form a tree.');
      }

      var rootCat = this.catmap.get(r[0]);

      if (rootCat === undefined) {
        this._root = null; // empty tree
      } else {
        this._root = rootCat;
      }
    }
  }

  _createClass(ProductCategoryTree, [{
    key: "get",

    /**
     * Returns category based on given ID. An error is thrown, if the tree does not contain the category.
     *
     * @param id category ID
     */
    value: function get(id) {
      var ret = this.catmap.get(id);

      if (ret === undefined) {
        throw new Error('Category not in this tree: ' + id);
      }

      return ret;
    }
    /**
     * Returns category based on given ID. Undefined is returned, if the tree does not contain the category.
     *
     * @param id category ID
     */

  }, {
    key: "getIfExists",
    value: function getIfExists(id) {
      return this.catmap.get(id);
    }
  }, {
    key: "has",
    value: function has(id) {
      return this.catmap.has(id);
    }
  }, {
    key: "parentOf",
    value: function parentOf(cat) {
      if (this.catmap.size === 0) {
        return null;
      }

      var ret = this.catmap.get(cat.parentId || '');
      return ret ? ret : null;
    }
  }, {
    key: "parentIdOfLevel",
    value: function parentIdOfLevel(category, level) {
      var parent = this.parentOf(category);

      if (parent) {
        if (parent.level > level) {
          return this.parentIdOfLevel(parent, level);
        }

        if (parent.level === level) {
          return parent.id;
        }
      }

      return null;
    }
  }, {
    key: "childrenOf",
    value: function childrenOf(cat) {
      var _this2 = this;

      if (this.catmap.size === 0) {
        return immutable_1.List();
      }

      return cat.childrenIds.reduce(function (children, categoryId) {
        var category = _this2.catmap.get(categoryId);

        return category ? children.push(category) : children;
      }, immutable_1.List());
    }
  }, {
    key: "predecessorsOf",
    value: function predecessorsOf(category) {
      if (this.catmap.size === 0) {
        return immutable_1.List();
      }

      var predecessors = immutable_1.List();
      var currentCategory = category;

      while (currentCategory.parentId) {
        var parent = this.catmap.get(currentCategory.parentId);

        if (!parent) {
          break;
        }

        predecessors = predecessors.push(parent);
        currentCategory = parent;
      }

      return predecessors;
    }
  }, {
    key: "getCategories",
    value: function getCategories() {
      return immutable_1.List(this.catmap.values());
    }
  }, {
    key: "getCategoriesAsMap",
    value: function getCategoriesAsMap() {
      return immutable_1.Map(this.catmap);
    }
  }, {
    key: "categoryTreeIdsMappedByLevel",
    value: function categoryTreeIdsMappedByLevel(categoryId) {
      var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : immutable_1.Map();
      var cat = this.get(categoryId);
      map = map.set(cat.level, cat.id);

      if (cat.parentId) {
        return this.categoryTreeIdsMappedByLevel(cat.parentId, map);
      }

      return map;
    }
  }, {
    key: "getLeafCategories",
    value: function getLeafCategories() {
      var result = immutable_1.List().asMutable();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.catmap.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              cat = _step$value[1];

          if (cat.childrenIds.isEmpty()) {
            result.push(cat);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result.asImmutable();
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.catmap.size === 0;
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.catmap.values();
    }
  }, {
    key: "gatherParents",
    value: function gatherParents(categoryIds, accParents) {
      var parents = immutable_1.Set();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = categoryIds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var categoryId = _step2.value;

          if (this.has(categoryId)) {
            var category = this.get(categoryId);

            if (utils_1.Utils.isString(category.parentId) && this.has(category.parentId)) {
              accParents = accParents.add(category.parentId);
              parents = parents.add(category.parentId);
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (parents.isEmpty()) {
        return accParents;
      }

      return this.gatherParents(parents, accParents);
    }
  }, {
    key: "gatherLeafCategories",
    value: function gatherLeafCategories(categoryIds, accLeafCategories) {
      var children = immutable_1.Set();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = categoryIds[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var cId = _step3.value;

          if (this.has(cId)) {
            var category = this.get(cId);

            if (category.childrenIds.isEmpty()) {
              accLeafCategories = accLeafCategories.add(category.id);
            } else {
              children = children.concat(category.childrenIds);
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (children.isEmpty()) {
        return accLeafCategories;
      }

      return this.gatherLeafCategories(children, accLeafCategories);
    }
  }, {
    key: "gatherChildren",
    value: function gatherChildren(categoryIds, accChildren) {
      var children = immutable_1.Set();
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = categoryIds[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var cId = _step4.value;

          if (this.has(cId)) {
            var category = this.get(cId);
            accChildren = accChildren.concat(category.childrenIds);
            children = children.concat(category.childrenIds);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (children.isEmpty()) {
        return accChildren;
      }

      return this.gatherChildren(children, accChildren);
    }
  }, {
    key: "hasParentInCategoryIds",
    value: function hasParentInCategoryIds(category, categoryIds) {
      if (utils_1.Utils.isString(category.parentId) && this.has(category.parentId)) {
        return categoryIds.contains(category.parentId) || this.hasParentInCategoryIds(this.get(category.parentId), categoryIds);
      } else {
        return false;
      }
    }
    /**
     * @param categoryId Tested category.
     * @param parentId Tested parent category.
     * @returns True if given categoryId has direct or indirect parent category with given parentId.
     */

  }, {
    key: "categoryHasDirectOrIndirectParent",
    value: function categoryHasDirectOrIndirectParent(categoryId, parentId) {
      if (!this.has(categoryId) || !this.has(parentId)) {
        return false;
      } else {
        var category = this.get(categoryId);

        if (category.parentId === null) {
          return false;
        }

        if (category.parentId === parentId) {
          return true;
        }

        return this.categoryHasDirectOrIndirectParent(category.parentId, parentId);
      }
    }
    /**
     * <p>Algorithm that excludes categories from currently included categories. It solves:</p>
     *
     * <ul>
     *     <li>The situation where some subcategory of currently included category is excluded: Currently included parent of excluded
     *     subcategory should be included no more, but parent's children are newly returned as included categories (inclusion shifts from
     *     parent to its children, excluding the excluded child).</li>
     *     <li>The situation when excluded categories are also directly included: It also excludes all children of the excluded
     *     categories, which could be potentially included.</li>
     * </ul>
     *
     * @param currentlyIncludedCategories Currently selected categories by user in general way.
     * @param categoriesToExclude Categories which should be excluded.
     * @returns List of resolved included categories after exclusion of given categories.
     */

  }, {
    key: "recomputeCategoriesAfterExclude",
    value: function recomputeCategoriesAfterExclude(currentlyIncludedCategories, categoriesToExclude) {
      if (categoriesToExclude.isEmpty()) {
        return currentlyIncludedCategories;
      }

      var currentlyIncludedCategoriesSet = currentlyIncludedCategories.toSet();
      var categoriesToExcludeSet = categoriesToExclude.toSet(); // we may directly remove categories to exclude with their children (we recompute included categories later on)

      var childrenCIdsToExclude = this.gatherChildren(categoriesToExcludeSet, immutable_1.Set());
      var cIdsToExcludeWithChildrenCIds = childrenCIdsToExclude.concat(categoriesToExclude);
      var includedCIdsWithoutCIdsToExcludeWithChildren = currentlyIncludedCategoriesSet.subtract(cIdsToExcludeWithChildrenCIds); // all parents of categories to exclude cannot be included...

      var parentsCIdsToExclude = this.gatherParents(categoriesToExcludeSet, immutable_1.Set());
      var self = this; // this may be optimized to not gather children of included categories for each

      function recomputeIncludedCategories(includedCIds, cIdsToExclude) {
        if (includedCIds.isEmpty()) {
          return immutable_1.Set();
        }

        var newIncludedCategoryIds = includedCIds.asMutable();
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = includedCIds[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var includedCId = _step5.value;

            // remove included parent category of a category to exclude (it cannot be included)
            if (parentsCIdsToExclude.has(includedCId)) {
              newIncludedCategoryIds.remove(includedCId);
            } // but include all possible children of that category which can be included


            var includedCIdChildren = self.gatherChildren(immutable_1.Set.of(includedCId), immutable_1.Set());
            var includedCIdChildrenToBeIncluded = includedCIdChildren.subtract(parentsCIdsToExclude).subtract(cIdsToExclude);
            newIncludedCategoryIds.concat(includedCIdChildrenToBeIncluded);
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        return newIncludedCategoryIds.asImmutable(); // asImmutable is not necessary, Set.asMutable().toList() creates immutable as exp.
      }

      return recomputeIncludedCategories(includedCIdsWithoutCIdsToExcludeWithChildren, cIdsToExcludeWithChildrenCIds).toList();
    }
  }, {
    key: "root",
    get: function get() {
      if (this._root === null) {
        throw new Error('Provided categories do not form a non-empty tree.');
      }

      return this._root;
    }
  }]);

  return ProductCategoryTree;
}();

exports.ProductCategoryTree = ProductCategoryTree;